<template>
    <div>
      <h2>{{ model }} Form</h2>

      <el-form :model="formData" label-width="120px">
        <el-form-item
          v-for="field in fields"
          :key="field.name"
          :label="field.verbose_name || field.name"
        >
          <template v-if="field.type === 'CharField'">
            <el-input v-model="formData[field.name]" />
          </template>
          <template v-else-if="field.type === 'IntegerField'">
            <el-input-number v-model="formData[field.name]" />
          </template>
          <template v-else-if="field.type === 'DateField'">
            <el-date-picker v-model="formData[field.name]" type="date" />
          </template>

          <template v-else-if="field.type === 'ForeignKey'">
          <!-- 관계 필드 처리 -->
          <el-select v-model="formData[field.name]" placeholder="Select">
            <el-option
              v-for="option in relatedOptions[field.name]"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            />
          </el-select>
        </template>



          <template v-else>
            <el-input v-model="formData[field.name]" />
          </template>
          
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveData">저장</el-button>
          <el-button @click="$emit('close')">취소</el-button>
        </el-form-item>
      </el-form>
    </div>
  </template>
  
  <script setup>
  import { ref, watch, onMounted } from 'vue';
  import axiosInstance from "@/api/axios";

  const props = defineProps({
    model: { type: String, required: true },
    data: { type: Object, default: () => ({}) },
  });
  const emit = defineEmits(['refresh', 'close']);
  
  const fields = ref([]);
  const formData = ref({});
  
  const fetchSchema = async () => {
    try {
      const schemaResponse = await axiosInstance.get(`/schema/${props.model}/`);
      
      fields.value = schemaResponse.data.fields;
      console.log("Fields===",fields.value)
    } catch (error) {
      console.error('Error fetching schema:', error);
    }
  };
  


const relatedOptions = ref({});

// 관계 필드의 옵션 데이터를 로드
const loadRelatedOptions = async () => {
  for (const field of fields.value) {
    if (field.type === 'ForeignKey' && field.related_model) {
      const response = await axiosInstance.get(`/${field.related_model.split('.').pop()}s/`);
      relatedOptions.value[field.name] = response.data.map((item) => ({
        label: item.name || item.id,
        value: item.id,
      }));
    }
  }
};


  watch(
    () => props.data,
    (newData) => {
      formData.value = { ...newData };
    },
    { immediate: true }
  );
  
  const saveData = async () => {
    try {
      if (formData.value.id) {
        await axiosInstance.put(`/${props.model.toLowerCase()}s/${formData.value.id}/`, formData.value);
      } else {
        await axiosInstance.post(`/${props.model.toLowerCase()}s/`, formData.value);
      }
      emit('refresh');
      alert('저장 완료!');
    } catch (error) {
      console.error('Error saving data:', error);
    }
  };
  
  // 스키마 데이터와 관계 데이터 로드
onMounted(async () => {
  await fetchSchema();
  await loadRelatedOptions();
});

  </script>
  